import React, { useEffect, useState } from 'react';
import GenericTemplate from '../components/templates/GenericTemplate';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Modal from '@material-ui/core/Modal'; // kamome
import IconButton from '@material-ui/core/IconButton';
import styles from '../components/templates/Template.module.css';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';

import { useHistory } from 'react-router';
import { Button } from '@material-ui/core';
import { Avatar } from '@material-ui/core';

import { getPostDetail } from '../common/firebase/post';
import { XROSS_POST_EX, Comment } from '../common/interface';

import { CATEGORY_TITLE_MAP } from '../common/report110';

//import { GetXrossServiceStatus } from "../common/GetXrossServiceStatus2";
// xross common function
import { getReportListByFilter } from '../common/firebase/report';

import { getSingleComment } from '../common/firebase/post';

// xross interface
import { REPORT_110 } from '../common/interface';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    table: {
      minWidth: 650,
    },
    form: {
      display: 'flex',
      gap: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  })
);

const Report: React.FC = () => {
  const classes = useStyles();
  const [report, setReport] = useState<REPORT_110[]>([]);
  const [nextList, setNextList] = useState<any>(new Date());

  const [searchUID, setSearchUID] = useState(''); // UIDを入力するためのステート
  const [postMap, setPostMap] = useState<{
    [key: string]: XROSS_POST_EX | null;
  }>({});
  const [replyCommentMap, setReplyCommentMap] = useState<{
    [key: string]: Comment | null;
  }>({});

  const filter = {
    uid: searchUID,
  };

  useEffect(() => {
    getFirebaseItems();
  }, []);

  // 投稿情報を取得して postMap に反映する関数
  const fetchPostDetails = async (reports: REPORT_110[]) => {
    const newPostMap = { ...postMap };

    for (const r of reports) {
      if (r.postId && !newPostMap[r.postId]) {
        const post = await getPostDetail(r.postId);
        newPostMap[r.postId] = post;
      }
    }
    setPostMap(newPostMap);
  };

  const fetchReplyComments = async (reports: REPORT_110[]) => {
    const newReplyMap = { ...replyCommentMap };

    for (const r of reports) {
      if (
        r.target === 'reply' &&
        r.postId &&
        r.replyId &&
        !newReplyMap[r.replyId]
      ) {
        const replyComment = await getSingleComment(r.postId, r.replyId);
        newReplyMap[r.replyId] = replyComment;
      }
    }
    setReplyCommentMap(newReplyMap);
  };

  // getFirebaseItems の末尾に追加する
  const getFirebaseItems = async () => {
    const list: REPORT_110[] = await getReportListByFilter(
      1000,
      nextList,
      filter
    );

    setReport((prev) => [...prev, ...list]);

    if (list.length > 0) {
      const latest = list[list.length - 1].createdAt;
      setNextList(latest);
    }
    await fetchPostDetails(list); // ここで post 情報も取得
    await fetchReplyComments(list); // 🔸ここが抜けていた
  };

  const history = useHistory();
  const handleClick = (id: string) => {
    console.log('PostList ->' + id);
    // history.push('/PostDetail/' + id);
  };

  return (
    <GenericTemplate title="報告（通報）管理">
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>No</TableCell>
              <TableCell>日時</TableCell>
              <TableCell>報告（通報）xrossユーザ</TableCell>
              <TableCell>投稿／返信コメント</TableCell>
              <TableCell>報告カテゴリ</TableCell>
              <TableCell>投稿</TableCell>

              <TableCell>返信コメント</TableCell>
            </TableRow>
          </TableHead>
          <>
            <TableBody>
              {report.map((report, idx) => (
                <TableRow
                  key={report.id}
                  hover
                  // onClick={(event) => handleClick(inquiry.uid)}
                >
                  <TableCell>{idx + 1}</TableCell>
                  <TableCell>
                    {report.createdAt?.toDate().toLocaleString()}
                  </TableCell>

                  <TableCell>
                    <div>
                      <Avatar src={report.xrossAvatarURL} />
                      {report.xrossUserName}
                    </div>
                    <div>{report.uid}</div>
                    <div>{report.xrossUserEmail}</div>
                  </TableCell>

                  <TableCell>{report.target}</TableCell>
                  <TableCell>
                    {CATEGORY_TITLE_MAP[report.category] ?? report.category}
                  </TableCell>
                  <TableCell>
                    {postMap[report.postId] ? (
                      <>
                        <div
                          style={{
                            display: 'flex',
                            gap: '4px',
                            flexWrap: 'wrap',
                          }}
                        >
                          {postMap[report.postId]?.contents?.map(
                            (url, index) => (
                              <>
                                <div>
                                  <div>
                                    <Avatar
                                      src={postMap[report.postId]?.avatarUrl}
                                      alt="投稿者アバター"
                                    />
                                  </div>
                                  <div>
                                    <img
                                      key={index}
                                      src={url}
                                      alt="投稿画像"
                                      style={{
                                        width: 60,
                                        height: 60,
                                        objectFit: 'cover',
                                        marginTop: 4, // 少し余白を追加
                                      }}
                                    />
                                  </div>
                                </div>
                              </>
                            )
                          )}
                        </div>
                        <div>{postMap[report.postId]?.text}</div>
                        <div style={{ color: 'blue' }}>{report.postId}</div>
                      </>
                    ) : (
                      <div>読み込み中...</div>
                    )}
                  </TableCell>
                  <TableCell>
                    {report.target === 'reply' && report.replyId ? (
                      replyCommentMap[report.replyId] ? (
                        <>
                          <div>
                            <Avatar
                              src={replyCommentMap[report.replyId]?.avatarUrl}
                              alt="コメント投稿者アバター"
                            />
                          </div>
                          <div style={{ marginTop: 4 }}>
                            <span>
                              {replyCommentMap[report.replyId]?.comment}
                            </span>
                          </div>
                          <div style={{ color: 'blue' }}>
                            {replyCommentMap[report.replyId]?.id}
                          </div>
                        </>
                      ) : (
                        <div>読み込み中...</div>
                      )
                    ) : (
                      <div>-</div>
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </>
        </Table>
      </TableContainer>
      <Button variant="contained" color="primary" onClick={getFirebaseItems}>
        次のLIST
      </Button>
    </GenericTemplate>
  );
};

export default Report;
